/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBarberProfileQueryResponse, GetApiBarberProfile400, GetApiBarberProfile401, GetApiBarberProfile403, GetApiBarberProfile404, GetApiBarberProfile500 } from "../entities/GetApiBarberProfile";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiBarberProfile } from "../api/getApiBarberProfile";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiBarberProfileQueryKey = () => [{ url: '/api/barber/profile' }] as const

export type GetApiBarberProfileQueryKey = ReturnType<typeof getApiBarberProfileQueryKey>

export function getApiBarberProfileQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiBarberProfileQueryKey()
        return queryOptions<GetApiBarberProfileQueryResponse, ResponseErrorConfig<GetApiBarberProfile400 | GetApiBarberProfile401 | GetApiBarberProfile403 | GetApiBarberProfile404 | GetApiBarberProfile500>, GetApiBarberProfileQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiBarberProfile({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Получить информацию о текущем мастере и статистику стрижек
 * @summary Профиль мастера
 * {@link /api/barber/profile}
 */
export function useGetApiBarberProfile<TData = GetApiBarberProfileQueryResponse, TQueryData = GetApiBarberProfileQueryResponse, TQueryKey extends QueryKey = GetApiBarberProfileQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<GetApiBarberProfileQueryResponse, ResponseErrorConfig<GetApiBarberProfile400 | GetApiBarberProfile401 | GetApiBarberProfile403 | GetApiBarberProfile404 | GetApiBarberProfile500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiBarberProfileQueryKey()
         

         const query = useQuery({
          ...getApiBarberProfileQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetApiBarberProfile400 | GetApiBarberProfile401 | GetApiBarberProfile403 | GetApiBarberProfile404 | GetApiBarberProfile500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}